var map = {
	"./AngryPressed.png": 77546,
	"./FlagFinland.png": 36047,
	"./FlagNorway.png": 84857,
	"./FlagSweden.png": 69759,
	"./HappyPressed.png": 25409,
	"./OkPressed.png": 84817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;